module.exports = __webpack_public_path__ + "static/media/Braviary_gaussian2.624f6c17.png";